import { observable, computed, action } from "mobx";
import { PATH_TIPOLOGICHE,PATH_UFFICI_CONVERVATORIE,PATH_PROVINCE,PATH_COMUNI,SEPARATORE  } from "../config/presdoc-fe-config";
import AjaxService from "../services/ajax-service";

class TipologicaStore {

  constructor(root) {   
    this.service = root.service
  }

  @observable statoInvio = []
  @observable ufficioConservatorie = []
  @observable tipoPubblicoUfficiale = [];
  @observable province = [];
  @observable tipoCCI = [];
  @observable statoProt = [];


  @action
  fetchStatoInvio(tipoPratica){
    this.service.doAjax('GET', `${PATH_TIPOLOGICHE}tipoPratica=${tipoPratica}&tipoRich=SI&ordinamento=ID`).then(response => {  
       if(response.success) {
         this.statoInvio = response.result.map(item => {
           return {
            optionValue: item.codice,
            optionLabel: item.descrizione,
            item
          }
       });  
     }
   })
  }

  
  @action
  fetchTipoCCI(tipoPratica){
    this.service.doAjax('GET', `${PATH_TIPOLOGICHE}tipoPratica=${tipoPratica}&tipoRich=TCCI`).then(response => {  
       if(response.success) {
         this.tipoCCI = response.result.map(item => {
           return {
            optionValue: item.codice,
            optionLabel: item.descrizione,
            item
          }
       });  
     }
   })
  }

  @action
  fetchStatoProt(tipoPratica){
    this.service.doAjax('GET', `${PATH_TIPOLOGICHE}tipoPratica=${tipoPratica}&tipoRich=SPROT`).then(response => {  
       if(response.success) {
         this.statoProt = response.result.map(item => {
           return {
            optionValue: item.codice,
            optionLabel: item.descrizione,
            item
          }
       });  
     }
   })
  }



@action
fetchUfficioConservatorie(stato,denominazioneCompatta = undefined, isValueIdUfficio = false ){

  let uri =  `${PATH_UFFICI_CONVERVATORIE}${stato}`;
  if(denominazioneCompatta !== undefined){
    uri= `${PATH_UFFICI_CONVERVATORIE}${stato}&denominazioneCompatta=${denominazioneCompatta}`
  }
  this.service.doAjax('GET', uri).then(response => {  
    if(response.success) {
      this.ufficioConservatorie = response.result.map(item => {
        return {
          optionValue: isValueIdUfficio?item.idUfficio:item.codiceUfficio,
          optionLabel: item.descrizione,
         item
       }
    });  
  }
})
}

@action
fetchTipoPubblicoUfficiale(){
  this.service.doAjax('GET', `${PATH_TIPOLOGICHE}tipoPratica=UN&tipoRich=TPU&ordinamento=ID`).then(response => {  
    if(response.success) {
      this.tipoPubblicoUfficiale = response.result.map(item => {
        return {
         optionValue: item.codice,
         optionLabel: item.descrizione,
         item
       }
    });  
  }
})
}

@action
  fetchProvince(loadEstero){
    this.service.doAjax('GET', PATH_PROVINCE).then(response => {
      let province = [];
        if(response.success) {
          province = response.result.map(item => {
            return {
            optionValue: item.codice,
            optionLabel: item.descrizione
            }
          });
          if(loadEstero) {
            province =
            [...province,
              {optionLabel:i18next.t("ESTERA"), optionValue:CODICE_STATO_ESTERO}
            ]
          }            
      }
      if(loadEstero) {
        this.provinceWithEstero = province;
 
      } else {
        this.province = province
      }
    })
  }

  /**
   * se provincia è null o undefined, ritorna un array vuoto
   * @param {*} provincia 
   *        status = 1 tutti, 0 solo attivi
   * @returns 
   */
  fetchComuni(provincia, status = 1) {
    return new Promise((resolve, reject) => {
      if (!provincia) {
        resolve([]);
      }
      this.service.doAjax('GET',`${PATH_COMUNI}${provincia}&status=${status}`).then(response => {   
          if(response.success) {
            let comuni = response.result.map(item => {
              return {
              optionValue: item.codice+SEPARATORE+item.descrizione,
              optionLabel: item.descrizione
              }
            });     
            resolve(comuni)
          } else {
            reject(response)
          }
      })
    });
  }



}

export default TipologicaStore;